module.exports = __webpack_public_path__ + "static/img/split.cf99750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/split.png
// module id = ZgK5
// module chunks = 2